
export class ReferralBo {
    id: string="00000000-0000-0000-0000-000000000000";
    clientId: string | null;
    clientName: string;
    referralStartTime: string;
    referralStatusLid: string | null;
    referralStatus: string;
    agencyId: string | null;
    agencyName: string;
    createdBy: string | null;
    createdIp: string;
    createdTime: string | null;
    modifiedBy: string | null;
    modifiedIp: string;
    modifiedTime: string | null;
    recordVersion: number;
    firstName: string;
    lastName: string;
    middleName: string;
    status_Name: string;
    userName: string;
    dOB: string | null;
    weight: number | null;
    aKA: string;
    isEin: string;
    medicaid: string;
    medicare: string;
    street: string;
    street2: string;
    apt: string;
    phone1: string;
    phone2: string;
    county: string;
    city: string;
    age: number | null;
    state: string;
    zipCode: string;
    ssn: string;
    email: string;
    requireEVV: boolean;
    internalId: string;
    pClientId: string;
    insuranceNo: string;
    billto_Name: string;
    billto_Street: string;
    billto_City: string;
    billto_State: string;
    billto_Zipcode: string;
    billto_Phone: string;
    billto_Email: string;
    mA_PMI: string;
    county_fiscalResponsibility: string;
    priorityStatusLid: string | null;
    genderLid: string | null;
    assessmentRatingLid: string | null;
    pCATypeLid: string | null;
    typeofWaiverLid: string | null;
    isEinLid: string | null;
    statusLid:string | null;
    loginUserId: string | null;
    locationName: string;
    name: string;
    gender_Name: string;
    assessmentRatingName: string;
    pCATypeName: string;
    typeofWaiverName: string;
    priorityStatusName: string;
    languageLids: any[] = [];
    pmi: string;
    isMNChoiceAssessment:boolean=false;
   // cfssModel : any[] = [];
    paySourceLid:string | null;
    cfssModel:string;
    isHomelessClient: boolean=false;
    employeeNames:string;
    clientTypeLid :  string | null;
    participantName: string
    participant_PhoneNumber : string;
    referer_Name : string;
    referer_PhoneNumber : string;
    referer_Email : string;
    lastAssessmentDate : string;
    followUpNotes : string;
    locationId: string | null;
    reasonForRejection: string;
}
export class GetReferalListBo {
    referralstartDate: string;
    referralEndDate: string;
    referralAge : string | null;
    ReferralStatusLid :string | null;
    currentpageno: number = 1;
    pageitem: number = 10;
    orderType: string = "asc";
    type: string = "string";
    field: string = "clientName";
    operator: string = "contains";
    value: string = "";
    orderColumn: string = "clientName";
    clientId: string | null;
    consultantId: string | null;
    referralDate: string | null;
    matchCase: boolean = false;
    agencyID: string | null;
    locationId: string | null;
    role: string;
    userid :  string | null;
    SearchColumn: string = "name";
    SearchText: string = "";
    languageLIds :string[];
}


export class WhereCondition {
    field: string="clientName";
    value: string="";
    operator: string="startswith";
    orderNo: number=1;
    predicate: string="and";
    type: string="string";
    matchCase:boolean=false;
}
export class columnWidth {
    column: string = "";
    width: number = 0;
}
export class ColumnChangeBO {
    id: number=0;
    userid: number=0;
    agencyId: number=0;
    column: string;
} 
export class ReferralClientRejectBO {
    ReferralId: string="00000000-0000-0000-0000-000000000000";
    reasonForRejection: string;
}

export class functionpermission {
    referralcreate: boolean = true;
    referralupdate: boolean = true;  
    referraledit: boolean = true;
    referralonboard: boolean = true;
    referralreject: boolean = true;
    referraldelete:boolean = true;
    referralnotescreate:boolean = true;
    referralnotesdelete:boolean = true;
    referralnotesupdate:boolean = true;
   }